import React, { useEffect, useState } from "react";
import InputSelectComLabel from "../../../../components/Input/InputSelectComLabel";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Colors from "../../../../template/Colors";
import SelectCustomIcon from "./SelectCustomIcon";
import Radio from "../../../../components/Radio/Radio";
import {
  Close as CloseIcon,
} from "@material-ui/icons";
import {
  Grid,
  Checkbox,
  withStyles,
} from "@material-ui/core";
import OpcaoAcaoBotaoMoreAnamnese from "./OpcaoAcaoBotaoMoreAnamnese";
import {
  CaixaSelecaoIcon,
  DataIcon,
  HoraIcon,
  ListaSuspensaIcon,
  MultiplaEscolhaIcon,
  RespostaCurtaIcon,
  RespostaLongaIcon,
  DataEHoraIcon,
  NumeroIcon,
} from "../../../../assets/img/svg";
import TextCharCounter from "../../../../components/TextCharCounter/TextCharCounter";
import TiposCampoAnamnese from "../../../Atendimento/Anamnese/TiposCampoAnamnese";
import TrashIcon from "../../../../components/Icon/Trash";
import classNames from "classnames";

const tiposCampo = [
  { label: " Resposta curta", value: "INPUT", icon: RespostaCurtaIcon },
  { label: " Resposta longa", value: "TEXT_AREA", icon: RespostaLongaIcon },
  { label: " Multipla escolha", value: "RADIO", icon: MultiplaEscolhaIcon },
  { label: " Caixa de seleção", value: "CHECKBOX", icon: CaixaSelecaoIcon },
  { label: " Lista suspensa", value: "COMBOBOX", icon: ListaSuspensaIcon },
  { label: " Data", value: "DATE", icon: DataIcon },
  { label: " Hora", value: "TIME", icon: HoraIcon },
  { label: " Data e hora", value: "DATETIME", icon: DataEHoraIcon },
  { label: " Número", value: "NUMBER", icon: NumeroIcon },
];

const CardModeloAnamnese = (props) => {
  const {
    classes,
    pergunta,
    tipo,
    handleChange,
    excluirResposta,
    listaResposta,
    handleChangeResposta,
    onClickAdicionarResposta,
    onClickOpcaoOutro,
    handleExcluirPergunta,
    handleDuplicarPergunta,
    handleAdicionarRespostaPadrao,
    tipoCampoPergunta,
    posicao,
    listaPerguntas,
    possuiRespostaPadrao,
    index,
  } = props;

  const [openMore, setOpenMore] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [placement, setPlacement] = useState(null);
  const [showTipo, setShowTipo] = useState(false);
  const [perguntas,setPerguntas]=useState([])

  useEffect(() => {
    setShowTipo(tipo === "CHECKBOX" || tipo === "COMBOBOX" || tipo === "RADIO")
  },[tipo])

  const tipoCampo = (index) => {
    switch (tipo) {
      case "CHECKBOX":
        return <Checkbox className={classes.colorOpcaoPerguntaTipo} disabled />;
      case "COMBOBOX":
        return <div className={classes.opcaoTipoComboBox}> {index + 1}. </div>;
      case "RADIO":
        return <Radio className={classes.colorOpcaoPerguntaTipo} disabled />;
      default:
        break;
    }
  };

  const handleCloseMore = (event) => {
    setOpenMore(false);
  };

  const handleClickMore = (newPlacement) => (event) => {
    setAnchorEl(event.currentTarget);
    setOpenMore((prev) => placement !== newPlacement || !prev);
    setPlacement(newPlacement);
  };

  const onChangeTipoComMultiplasRespostas = (
    e,
    tipo,
    posicaoResposta,
    posicaoPergunta
  ) => {
    let perguntas = listaPerguntas;
    if (tipo === "RADIO") {
      perguntas[posicaoPergunta].respostas.map((item, index) => {
        item.valorResposta = posicaoResposta === index;
        
      });
    }

    if (tipo === "CHECKBOX") {
      perguntas[posicaoPergunta].respostas.forEach((item, index) => {
        item.valorResposta = !!item.valorResposta;
      });
      perguntas[posicaoPergunta].respostas[
        posicaoResposta
      ].valorResposta = !perguntas[posicaoPergunta].respostas[
        posicaoResposta
      ].valorResposta;
    }

    if (tipo === "COMBOBOX") {
      perguntas[posicaoPergunta].respostas.forEach((item) => {
        item.valorResposta = item?.nome === e?.nome;
      });
    }
    setPerguntas([...perguntas]);
  };

  const onChange = (posicaoPergunta, e, tipo) => {
    let perguntas = listaPerguntas;
    let value = '';
    if (tipo === "TEXT_AREA" || tipo === "INPUT" || tipo === "NUMBER") {
      value = e.target?.value

    } else {
      value = e;

    }
    
    perguntas[posicaoPergunta].respostas[0] = {
        valorResposta: value,
      };

    setPerguntas([...perguntas]);
  };

  const onChangeOutro = (e, posicaoResposta, posicaoPergunta) => {
    if (
      listaPerguntas[posicaoPergunta].respostas[posicaoResposta].valorResposta
    ) {
      listaPerguntas[posicaoPergunta].respostas[posicaoResposta].outro =
        e.target.value;
    }

    setPerguntas([...listaPerguntas]);
  };


  const tamanhoTipo = tipo => {
    if (tipo === "DATE" || tipo === "TIME" || tipo === "DATETIME") {
      return 4
    } else {
      return 12
    }
  };


  const possuiOutro = listaResposta?.some((item) => item.isOutro);

  return (
    <div className={classes.cardEIcon}>
      <div>
        <DragHandleIcon id={`cfg-cma-ico-drg-${index}`} className={classes.dragHandleIcon} />
      </div>
      <Grid className={classes.card}>
        <Grid className={classes.cardHeader}>
          <Grid item xs={8}>
            <InputSelectComLabel
              id={`cfg-cma-inp-tit-${index}`}
              onChange={(event) => handleChange(event, "pergunta")}
              label={"Titulo da pergunta"}
              value={pergunta || ""}
              maxLength={500}
            />
            <TextCharCounter currQuantity={pergunta.length || 0} limit={500} />
          </Grid>
          {posicao}
          <Grid item xs={4}>
            <SelectCustomIcon
              id={`cfg-cma-sel-tip-${index}`}
              label={"Tipo do campo"}
              isSelect
              onChange={(event) => handleChange(event, "tipo")}
              value={tipoCampoPergunta}
              options={tiposCampo}
            />
          </Grid>
        </Grid>
        <Grid>
          {showTipo &&
            listaResposta.map((item, indexResposta) => {
              return (
                <div key={indexResposta}>
                  <div className={classes.contentOpcaoPergunta}>
                    <div className={classes.opcaoPerguntaTipo}>
                      {tipoCampo(indexResposta)}
                    </div>
                    {item.isOutro ? (
                      <div className={classes.opcaoOutro}>Outro</div>
                    ) : (
                      <InputSelectComLabel
                        id={`cfg-cma-inp-opc-${index}-${indexResposta}`}
                        className={classes.opcaoPerguntaInput}
                        maxLength={50}
                        onChange={(event) => handleChangeResposta(event, indexResposta)}
                        value={item.nome || ""}
                      />
                    )}
                    <div
                      id={`cfg-cma-ico-exc-${index}-${indexResposta}`}
                      onClick={() => excluirResposta(indexResposta)}
                      className={classes.buttonExcluir}
                    >
                      <CloseIcon className={classes.excluirIcon} />
                    </div>
                  </div>
                </div>
              );
            })}
        </Grid>
        {showTipo && (
          <div className={classes.contentAdicionarResposta}>
            <span
              id={`cfg-cma-btn-ado-${index}`}
              className={classes.adicionarResposta}
              onClick={onClickAdicionarResposta}
            >
              Adicionar opção
            </span>
            {!possuiOutro && tipo !== "COMBOBOX" && (
              <>
                {` ou `}
                <span
                  id={`cfg-cma-btn-out-${index}`}
                  className={classes.adicionarResposta}
                  onClick={onClickOpcaoOutro}
                >
                  adicionar "Outro"
                </span>
              </>
            )}
          </div>
        )}
        {possuiRespostaPadrao &&
          <Grid container direction="row" className={classNames([classes.contentContainer, (tipo === "RADIO" || tipo === "CHECKBOX") ? classes.contentRadioCheckBox : null])}>
            <div id={`cfg-cma-btn-rem-${index}`} className={classes.button} onClick={handleAdicionarRespostaPadrao}>
              <TrashIcon width={"20"} height={"20"} color={"#505050"} onClick={handleAdicionarRespostaPadrao}></TrashIcon>
            </div>
            <Grid item xs={tamanhoTipo(tipo)} key={index}>
              <TiposCampoAnamnese
                id={`cfg-cma-inp-res-${index}`}
                readOnly={false}
                label={possuiRespostaPadrao ? "" : pergunta}
                tipocampo={tipo}
                respostas={listaResposta || []}
                onChange={(e, tipo) => onChange(index, e, tipo)}
                onChangeTipoComMultiplasRespostas={(e, tipo, posicaoResposta) =>
                  onChangeTipoComMultiplasRespostas(e, tipo, posicaoResposta, index)
                }
                onChangeOutro={(e, posicaoResposta) =>
                  onChangeOutro(e, posicaoResposta, index)
                }
                textLength={listaPerguntas[index]?.respostas[0]?.valorResposta?.length || 0}
                possuiRespostaPadrao={possuiRespostaPadrao}
              />
            </Grid>
          </Grid>}
      </Grid>
      <div>
        <div
          id={`cfg-cma-btn-mor-${index}`}
          className={classes.buttonMore}
          onClick={handleClickMore("bottom-end")}
        >
          <MoreVertIcon className={classes.moreVertIcon} />
        </div>
        <div key={index} onClick={handleCloseMore}>
          <OpcaoAcaoBotaoMoreAnamnese
            idPrefix={`cfg-cma-${index}`}
            openMore={openMore}
            anchorEl={anchorEl}
            placement={placement}
            handleDuplicarPergunta={handleDuplicarPergunta}
            handleExcluirPergunta={handleExcluirPergunta}
            handleCloseMore={handleCloseMore}
            handleAdicionarRespostaPadrao={handleAdicionarRespostaPadrao}
            listaPerguntas={listaPerguntas}
            indexItem={index}
            tipo={tipo}
          />
  </div>
      </div>
    </div>
  );
};

const style = (theme) => ({
  contentRadioCheckBox:{
    padding: "10px 17px 14px",
  },
  contentContainer: {
    display:"flex",
    flexDirection:"row-reverse",
    alignContent:"flex-start",
    justifyContent:"flex-end",
    width: "100%",
    height: "100%",
    borderBottomLeftRadius: "15px",
    overflow: "hidden",
    gap:"10px",
    flexWrap:"noWrap"
  },
  button:{
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    borderRadius:"50%",
    height:"36px",
    width:"36px",
    cursor:"pointer",
  },
  card: {
    borderRadius: 10,
    padding: 16,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    background: "#ffff",
    marginBottom: "16px",
  },
  dragHandleIcon: {
    color: Colors.commons.gray7,
    marginRight: "16px",
  },
  cardHeader: {
    display: "flex",
    marginBottom: "5px",
  },
  cardEIcon: {
    display: "flex",
  },
  excluirIcon: {
    color: Colors.commons.gray7,
    marginTop: "5px",
  },
  contentOpcaoPergunta: {
    display: "flex",
    alignItems: "center",
    marginTop: 5,
  },
  opcaoPerguntaInput: {
    width: "100%",
  },
  opcaoTipoComboBox: {
    color: Colors.commons.gray9,
    width: 25,
  },
  opcaoPerguntaTipo: {
    marginRight: 8,
    textAlign: "end",
  },
  colorOpcaoPerguntaTipo: {
    color: Colors.commons.gray7,
  },
  buttonExcluir: {
    cursor: "pointer",
  },
  adicionarResposta: {
    color: Colors.commons.padrao,
    textDecorationLine: "underline",
    cursor: "pointer",
  },
  contentAdicionarResposta: {
    marginTop: 8,
  },
  divOpcaoOutro: {
    display: "flex",
  },
  opcaoOutro: {
    display: "flex",
    alignItems: "end",
    width: "100%",
    marginTop: 5, 
  },
  moreVertIcon: {
    color: Colors.commons.gray9,
  },
  buttonMore: {
    cursor: "pointer",
    width: "30px",
    height: "30px",
    borderRadius: "100px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "10px",
    "&:hover": {
      background: "#EAEAEA",
    },
  },
});

export default withStyles(style)(CardModeloAnamnese);
